// src/Components/PushListener.tsx
import React from 'react';
import usePushNotifications from '../Hooks/usePushNotifications.ts';

export default function PushListener() {
  // Now this executes at the top level of a component.
  usePushNotifications();
  return null;
}
